module.exports = __webpack_public_path__ + "images/fa-lf-instructor-ned-krastev-mobile.webp";